import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsDefined,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { ContractorCreateDto } from './contractor-create.dto';

export const CONTRACTOR_RELATION_MAX_ITEMS = 200;

/**
 * Body of POST /contractor/full: the contractor plus the full set of regions
 * and bumper users it starts with, persisted in one transaction.
 */
export class ContractorFullCreateDto {
  @ApiProperty({ type: () => ContractorCreateDto })
  @Expose()
  @IsDefined()
  @ValidateNested()
  @Type(() => ContractorCreateDto)
  contractor!: ContractorCreateDto;

  @ApiProperty({
    type: [String],
    format: 'uuid',
    description: 'Region ids the contractor works in (may be empty).',
  })
  @Expose()
  @IsArray()
  @ArrayMaxSize(CONTRACTOR_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds!: string[];

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description:
      'User ids linked as bumpers. Only accepted when the contractor has bumpers available.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(CONTRACTOR_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  bumperUserIds?: string[];
}
